import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '@rezolved/auth';
import { environment } from '../../../environments/environment';
import { GetAllMerchantsResponse, MerchantResponse } from '../models/mxp-merchant.model';

@Injectable({ providedIn: 'root' })
export class MerchantService {
  private readonly url = environment.identityUrl.replace(/\/$/, '') + '/api/mxp-merchants';
  private merchantSubject = new BehaviorSubject<MerchantResponse | null>(null);
  merchant$ = this.merchantSubject.asObservable();

  constructor(private readonly http: HttpClient, private authService: AuthService) {}

  getMerchantById(id: string): Observable<MerchantResponse> {
    return this.http.get<MerchantResponse>(this.url + '/' + encodeURIComponent(id));
  }

  getMerchant(): Observable<MerchantResponse> {
    return this.http.get<MerchantResponse>(this.url + '/current');
  }

  getAllMerchants(): Observable<GetAllMerchantsResponse> {
    return this.http.get<GetAllMerchantsResponse>(this.url);
  }

  loadMerchant(): Observable<MerchantResponse | null> {
    return this.authService.user$.pipe(
      map(user => user?.['https://rezolve.com/mxp_merchant_id']),
      distinctUntilChanged(),
      switchMap(merchantId => {
        if (!merchantId) {
          return of(null);
        }

        return this.getMerchant().pipe(
          catchError(error => {
            console.error('Error loading merchant:', error);
            return of(null);
          })
        );
      }),
      tap(merchant => this.merchantSubject.next(merchant))
    );
  }

  refreshMerchant(): void {
    this.loadMerchant().subscribe(); // Fire and forget
  }
}
